import { createBrowserRouter } from "react-router-dom";
import Home from "../modules/home";
import AuthScreen from "../modules/auth";
import Profile from "../modules/profile";
import DetailPost from "../modules/detail-post";

export default createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/:name",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthScreen />,
  },
  {
    path: "/profile/:id",
    element: <Profile />,
  },
  {
    path: "/detail-post/:id",
    element: <DetailPost />,
  },
]);
